<form [formGroup]="formGroup" id="step3Form">
  <div class="step3-form-container">
    <div class="row" [class.mark-red-border]="controls.currentlyDetained.value === true && mode === 'employee'">
      @if (controls.currentlyDetained; as currentlyDetained) {
        <div class="standard-form-field radio-form-field currentlyDetained-field required-field">
          <label id="currentlyDetainedLabel" [class.invalid]="currentlyDetained.touched && currentlyDetained.invalid">
            {{ 'PERSONAL_DATA_FORM.CURRENTLY-DETAINED.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="currentlyDetained"
            formControlName="currentlyDetained"
            [required]="true"
            [attr.aria-labelledby]="'currentlyDetainedLabel'"
            [attr.aria-invalid]="currentlyDetained.touched && currentlyDetained.invalid ? 'true' : null"
            (keydown)="firstInputKeydown($event)">
            <mat-radio-button id="currentlyDetained-0" [value]="true">
              {{ 'COMMON.GENERAL.YES' | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="false">
              {{ 'COMMON.GENERAL.NO' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>
    @if (controls.currentlyDetained.value === true) {
      <!-- ====================================================================== 1 ============================= -->
      <div class="row" [class.mark-red-border]="controls.inGuardedCentre.value === true && mode === 'employee'">
        @if (controls.inGuardedCentre; as inGuardedCentre) {
          <div class="standard-form-field radio-form-field inGuardedCentre-field required-field">
            <label id="inGuardedCentreLabel" [class.invalid]="inGuardedCentre.touched && inGuardedCentre.invalid">
              {{ 'PERSONAL_DATA_FORM.DETAINED_IN_GUARDED_CENTRE' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="inGuardedCentre"
              formControlName="inGuardedCentre"
              [required]="true"
              [attr.aria-labelledby]="'inGuardedCentreLabel'"
              [attr.aria-invalid]="inGuardedCentre.touched && inGuardedCentre.invalid ? 'true' : null">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.inGuardedCentre.value === true) {
          @if (controls.inGuardedCentreComment; as inGuardedCentreComment) {
            <div class="standard-form-field three-fourth-field inGuardedCentreComment-field">
              <label
                for="inGuardedCentreComment"
                [class.invalid]="inGuardedCentreComment.touched && inGuardedCentreComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="inGuardedCentreComment"
                  formControlName="inGuardedCentreComment"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="inGuardedCentreComment.touched && inGuardedCentreComment.invalid ? 'true' : null"
                  [attr.aria-describedby]="
                    inGuardedCentreComment.touched && inGuardedCentreComment.invalid
                      ? 'inGuardedCentreCommentError'
                      : null
                  "></textarea>
                <!-- ERROR -->
                @if (inGuardedCentreComment.touched && inGuardedCentreComment.invalid) {
                  <mat-error id="inGuardedCentreCommentError">
                    {{ inGuardedCentreComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 2 ============================= -->
      <div class="row" [class.mark-red-border]="controls.inDetentionCentre.value === true && mode === 'employee'">
        @if (controls.inDetentionCentre; as inDetentionCentre) {
          <div class="standard-form-field radio-form-field inDetentionCentre-field required-field">
            <label id="inDetentionCentreLabel" [class.invalid]="inDetentionCentre.touched && inDetentionCentre.invalid">
              {{ 'PERSONAL_DATA_FORM.IN_DETENTION_CENTRE' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="inDetentionCentre"
              formControlName="inDetentionCentre"
              [required]="true"
              [attr.aria-labelledby]="'inDetentionCentreLabel'"
              [attr.aria-invalid]="inDetentionCentre.touched && inDetentionCentre.invalid ? 'true' : null">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.inDetentionCentre.value === true) {
          @if (controls.inDetentionCentreComment; as inDetentionCentreComment) {
            <div class="standard-form-field three-fourth-field inDetentionCentreComment-field">
              <label
                for="inDetentionCentreComment"
                [class.invalid]="inDetentionCentreComment.touched && inDetentionCentreComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="inDetentionCentreComment"
                  formControlName="inDetentionCentreComment"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    inDetentionCentreComment.touched && inDetentionCentreComment.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    inDetentionCentreComment.touched && inDetentionCentreComment.invalid
                      ? 'inDetentionCentreCommentError'
                      : null
                  "></textarea>
                <!-- ERROR -->
                @if (inDetentionCentreComment.touched && inDetentionCentreComment.invalid) {
                  <mat-error id="inDetentionCentreCommentError">
                    {{ inDetentionCentreComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 3 ============================= -->
      <div class="row" [class.mark-red-border]="controls.hasBanOnLeavingCountry.value === true && mode === 'employee'">
        @if (controls.hasBanOnLeavingCountry; as hasBanOnLeavingCountry) {
          <div class="standard-form-field radio-form-field hasBanOnLeavingCountry-field required-field">
            <label
              id="hasBanOnLeavingCountryLabel"
              [class.invalid]="hasBanOnLeavingCountry.touched && hasBanOnLeavingCountry.invalid">
              {{ 'PERSONAL_DATA_FORM.HAS_BAN_ON_LEAVING_THE_COUNTRY' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="hasBanOnLeavingCountry"
              formControlName="hasBanOnLeavingCountry"
              [required]="true"
              [attr.aria-labelledby]="'hasBanOnLeavingCountryLabel'"
              [attr.aria-invalid]="hasBanOnLeavingCountry.touched && hasBanOnLeavingCountry.invalid ? 'true' : null">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.hasBanOnLeavingCountry.value === true) {
          @if (controls.hasBanOnLeavingCountryComment; as hasBanOnLeavingCountryComment) {
            <div class="standard-form-field three-fourth-field hasBanOnLeavingCountryComment-field">
              <label
                for="hasBanOnLeavingCountryComment"
                [class.invalid]="hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="hasBanOnLeavingCountryComment"
                  formControlName="hasBanOnLeavingCountryComment"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid
                      ? 'hasBanOnLeavingCountryCommentError'
                      : null
                  "></textarea>
                <!-- ERROR -->
                @if (hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid) {
                  <mat-error id="hasBanOnLeavingCountryCommentError">
                    {{ hasBanOnLeavingCountryComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 4 ============================= -->
      <div
        class="row"
        [class.mark-red-border]="controls.hasSentenceOfImprisonment.value === true && mode === 'employee'">
        @if (controls.hasSentenceOfImprisonment; as hasSentenceOfImprisonment) {
          <div class="standard-form-field radio-form-field hasSentenceOfImprisonment-field required-field">
            <label
              id="hasSentenceOfImprisonmentLabel"
              [class.invalid]="hasSentenceOfImprisonment.touched && hasSentenceOfImprisonment.invalid">
              {{ 'PERSONAL_DATA_FORM.SENTENCED_IMPRISONMENT' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="hasSentenceOfImprisonment"
              formControlName="hasSentenceOfImprisonment"
              [required]="true"
              [attr.aria-labelledby]="'hasSentenceOfImprisonmentLabel'"
              [attr.aria-invalid]="
                hasSentenceOfImprisonment.touched && hasSentenceOfImprisonment.invalid ? 'true' : null
              ">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.hasSentenceOfImprisonment.value === true) {
          @if (controls.hasSentenceOfImprisonmentComment; as hasSentenceOfImprisonmentComment) {
            <div class="standard-form-field three-fourth-field hasSentenceOfImprisonmentComment-field">
              <label
                for="hasSentenceOfImprisonmentComment"
                [class.invalid]="hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="hasSentenceOfImprisonmentComment"
                  formControlName="hasSentenceOfImprisonmentComment"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid
                      ? 'hasSentenceOfImprisonmentCommentError'
                      : null
                  "></textarea>
                <!-- ERROR -->
                @if (hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid) {
                  <mat-error id="hasSentenceOfImprisonmentCommentError">
                    {{ hasSentenceOfImprisonmentComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 5 ============================= -->
      <div class="row" [class.mark-red-border]="controls.temporarilyArrested.value === true && mode === 'employee'">
        @if (controls.temporarilyArrested; as temporarilyArrested) {
          <div class="standard-form-field radio-form-field temporarilyArrested-field required-field">
            <label
              id="temporarilyArrestedLabel"
              [class.invalid]="temporarilyArrested.touched && temporarilyArrested.invalid">
              {{ 'PERSONAL_DATA_FORM.TEMPORARILY_ARRESTED' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="temporarilyArrested"
              formControlName="temporarilyArrested"
              [required]="true"
              [attr.aria-labelledby]="'temporarilyArrestedLabel'"
              [attr.aria-invalid]="temporarilyArrested.touched && temporarilyArrested.invalid ? 'true' : null">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.temporarilyArrested.value === true) {
          @if (controls.temporarilyArrestedComment; as temporarilyArrestedComment) {
            <div class="standard-form-field three-fourth-field temporarilyArrestedComment-field">
              <label
                for="temporarilyArrestedComment"
                [class.invalid]="temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="temporarilyArrestedComment"
                  formControlName="temporarilyArrestedComment"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid
                      ? 'temporarilyArrestedCommentError'
                      : null
                  "></textarea>
                <!-- ERROR -->
                @if (temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid) {
                  <mat-error id="temporarilyArrestedCommentError">
                    {{ temporarilyArrestedComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
    }

    <div class="row">
      @if (controls.wasSentencedInPoland; as wasSentencedInPoland) {
        <div class="standard-form-field radio-form-field wasSentencedInPoland-field required-field">
          <label
            id="wasSentencedInPolandLabel"
            [class.invalid]="wasSentencedInPoland.touched && wasSentencedInPoland.invalid">
            {{ 'PERSONAL_DATA_FORM.WAS-SENTENCED-IN-POLAND.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="wasSentencedInPoland"
            formControlName="wasSentencedInPoland"
            [required]="true"
            [attr.aria-labelledby]="'wasSentencedInPolandLabel'"
            [attr.aria-invalid]="wasSentencedInPoland.touched && wasSentencedInPoland.invalid ? 'true' : null">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.wasSentencedInPoland.value === true) {
        @if (controls.sentenceReason; as sentenceReason) {
          <div class="standard-form-field three-fourth-field sentenceReason-field">
            <label for="applicantSentenceReason" [class.invalid]="sentenceReason.touched && sentenceReason.invalid">
              {{ 'PERSONAL_DATA_FORM.SENTENCE-REASON.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="applicantSentenceReason"
                formControlName="sentenceReason"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"
                [attr.aria-required]="false"
                [attr.aria-invalid]="sentenceReason.touched && sentenceReason.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  sentenceReason.touched && sentenceReason.invalid ? 'sentenceReasonError' : null
                "></textarea>
              <!-- ERROR -->
              @if (sentenceReason.touched && sentenceReason.invalid) {
                <mat-error id="sentenceReasonError">
                  {{ sentenceReason.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>

    <div class="row">
      @if (controls.currentlySubjectOfProceedings; as currentlySubjectOfProceedings) {
        <div class="standard-form-field radio-form-field currentlySubjectOfProceedings-field required-field">
          <label
            id="currentlySubjectOfProceedingsLabel"
            [class.invalid]="currentlySubjectOfProceedings.touched && currentlySubjectOfProceedings.invalid">
            {{ 'PERSONAL_DATA_FORM.CURRENTLY-SUBJECT-OF-PROCEEDINGS.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="currentlySubjectOfProceedings"
            formControlName="currentlySubjectOfProceedings"
            [required]="true"
            [attr.aria-labelledby]="'currentlySubjectOfProceedingsLabel'"
            [attr.aria-invalid]="
              currentlySubjectOfProceedings.touched && currentlySubjectOfProceedings.invalid ? 'true' : null
            ">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.currentlySubjectOfProceedings.value === true) {
        @if (controls.proceedingsReason; as proceedingsReason) {
          <div class="standard-form-field three-fourth-field proceedingsReason-field">
            <label
              for="applicantProceedingsReason"
              [class.invalid]="proceedingsReason.touched && proceedingsReason.invalid">
              {{ 'PERSONAL_DATA_FORM.PROCEEDINGS-REASON.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="applicantProceedingsReason"
                formControlName="proceedingsReason"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"
                [attr.aria-required]="false"
                [attr.aria-invalid]="proceedingsReason.touched && proceedingsReason.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  proceedingsReason.touched && proceedingsReason.invalid ? 'proceedingsReasonError' : null
                "></textarea>
              <!-- ERROR -->
              @if (proceedingsReason.touched && proceedingsReason.invalid) {
                <mat-error id="proceedingsReasonError">
                  {{ proceedingsReason.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>

    <div class="row">
      @if (controls.isComplyingWithFiscalObligation; as isComplyingWithFiscalObligation) {
        <div class="standard-form-field radio-form-field isComplyingWithFiscalObligation-field required-field">
          <label
            id="isComplyingWithFiscalObligationLabel"
            [class.invalid]="isComplyingWithFiscalObligation.touched && isComplyingWithFiscalObligation.invalid">
            {{ 'PERSONAL_DATA_FORM.IS-COMPLYING-WITH-FISCAL-OBLIGATION.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="isComplyingWithFiscalObligation"
            formControlName="isComplyingWithFiscalObligation"
            [required]="true"
            [attr.aria-labelledby]="'isComplyingWithFiscalObligationLabel'"
            [attr.aria-invalid]="
              isComplyingWithFiscalObligation.touched && isComplyingWithFiscalObligation.invalid ? 'true' : null
            "
            (keydown.Tab)="
              maritalStatus === 'Żonaty' || maritalStatus === 'Mężatka' ? undefined : emitLastFieldTabPressed($event)
            ">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>

    @if (maritalStatus === 'Żonaty' || maritalStatus === 'Mężatka') {
      <nz-divider [nzText]="travelers" nzOrientation="center">
        <ng-template #travelers>
          <h5>{{ 'PERSONAL_DATA_FORM.SPOUSE_DATA' | translate }}</h5>
        </ng-template>
      </nz-divider>
      <div class="row">
        @if (controls.spouseName; as spouseName) {
          <div class="standard-form-field spouseName-field required-field">
            <label for="spouseNameInput" [class.invalid]="spouseName.touched && spouseName.invalid">
              {{ 'PERSONAL_DATA_FORM.NAME.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="spouseNameInput"
                type="text"
                maxlength="200"
                placeholder="{{ 'PERSONAL_DATA_FORM.NAME.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="spouseName.touched && spouseName.invalid ? 'true' : null"
                [attr.aria-describedby]="spouseName.touched && spouseName.invalid ? 'spouseNameError' : null"
                [formControl]="spouseName" />
              <!-- ERROR -->
              @if (spouseName.touched && spouseName.invalid) {
                <mat-error id="spouseNameError">
                  {{ spouseName.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.spouseSurname; as spouseSurname) {
          <div class="standard-form-field spouseSurname-field required-field">
            <label for="spouseSurnameInput" [class.invalid]="spouseSurname.touched && spouseSurname.invalid">
              {{ 'PERSONAL_DATA_FORM.SURNAME.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="spouseSurnameInput"
                type="text"
                maxlength="200"
                placeholder="{{ 'PERSONAL_DATA_FORM.SURNAME.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="spouseSurname.touched && spouseSurname.invalid ? 'true' : null"
                [attr.aria-describedby]="spouseSurname.touched && spouseSurname.invalid ? 'spouseSurnameError' : null"
                [formControl]="spouseSurname" />
              <!-- ERROR -->
              @if (spouseSurname.touched && spouseSurname.invalid) {
                <mat-error id="spouseSurnameError">
                  {{ spouseSurname.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.spousePreviousName; as spousePreviousName) {
          <div class="standard-form-field spousePreviousName-field">
            <label
              for="spousePreviousNameInput"
              [class.invalid]="spousePreviousName.touched && spousePreviousName.invalid">
              {{ 'PERSONAL_DATA_FORM.PREVIOUS-NAME.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="spousePreviousNameInput"
                type="text"
                maxlength="200"
                placeholder="{{ 'PERSONAL_DATA_FORM.PREVIOUS-NAME.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="false"
                [attr.aria-invalid]="spousePreviousName.touched && spousePreviousName.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  spousePreviousName.touched && spousePreviousName.invalid ? 'spousePreviousNameError' : null
                "
                [formControl]="spousePreviousName" />
              <!-- ERROR -->
              @if (spousePreviousName.touched && spousePreviousName.invalid) {
                <mat-error id="spousePreviousNameError">
                  {{ spousePreviousName.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.spousePreviousSurname; as spousePreviousSurname) {
          <div class="standard-form-field spousePreviousSurname-field">
            <label
              for="spousePreviousSurnameInput"
              [class.invalid]="spousePreviousSurname.touched && spousePreviousSurname.invalid">
              {{ 'PERSONAL_DATA_FORM.PREVIOUS-SURNAME.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="spousePreviousSurnameInput"
                type="text"
                maxlength="200"
                placeholder="{{ 'PERSONAL_DATA_FORM.PREVIOUS-SURNAME.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="false"
                [attr.aria-invalid]="spousePreviousSurname.touched && spousePreviousSurname.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  spousePreviousSurname.touched && spousePreviousSurname.invalid ? 'spousePreviousSurnameError' : null
                "
                [formControl]="spousePreviousSurname" />
              <!-- ERROR -->
              @if (spousePreviousSurname.touched && spousePreviousSurname.invalid) {
                <mat-error id="spousePreviousSurnameError">
                  {{ spousePreviousSurname.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      <div class="row">
        @if (controls.spouseDob; as spouseDob) {
          <div class="standard-form-field spouseDob-field required-field">
            <label for="spouseDobInput" [class.invalid]="spouseDob.touched && spouseDob.invalid">
              {{ 'PERSONAL_DATA_FORM.DATE-OF-BIRTH.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" (click)="picker.open()">
              <input
                matInput
                (focus)="picker.open()"
                id="spouseDobInput"
                #spouseDobInput
                [matDatepicker]="picker"
                placeholder="{{ 'PERSONAL_DATA_FORM.DATE-OF-BIRTH.PLACEHOLDER' | translate }}"
                [min]="minValidDate"
                [max]="maxValidDate"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="spouseDob.touched && spouseDob.invalid ? 'true' : null"
                [attr.aria-describedby]="spouseDob.touched && spouseDob.invalid ? 'spouseDobError' : null"
                [readonly]="true"
                [formControl]="spouseDob" />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>
              <mat-datepicker
                #picker
                [startView]="'month'"
                [startAt]="spouseDob.value || '2000'"
                (closed)="spouseDobInput.blur()">
              </mat-datepicker>
              <!-- ERROR -->
              @if (spouseDob.touched && spouseDob.invalid) {
                <mat-error id="spouseDobError">
                  {{ spouseDob.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.spouseSex; as spouseSex) {
          <div class="standard-form-field spouseSex-field required-field">
            <label id="spouseSexLabel" [class.invalid]="spouseSex.touched && spouseSex.invalid">
              {{ 'PERSONAL_DATA_FORM.SEX.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                [formControl]="spouseSex"
                id="spouseSexInput"
                panelClass="standard-select"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-labelledby]="'spouseSexLabel'"
                [attr.aria-invalid]="spouseSex.touched && spouseSex.invalid ? 'true' : null"
                [attr.aria-describedby]="spouseSex.touched && spouseSex.invalid ? 'spouseSexError' : null">
                @for (item of selectsValues.SEX; track item) {
                  <mat-option [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (spouseSex.touched && spouseSex.invalid) {
                <mat-error id="spouseSexError">
                  {{ spouseSex.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        <div class="standard-form-field citizenship-field required-field">
          <!-- Filtering out id: 616 -> Poland. Person that has Polish citizenship cannot apply for temp. permit -->
          <app-country-select
            class="country-select"
            [fieldControl]="controls.spouseCitizenship"
            [fieldKey]="'spouseCitizenship'"
            [isRequired]="true"
            [fieldLabelKey]="'CITIZENSHIP'">
          </app-country-select>
        </div>
      </div>
      <div class="row">
        <div class="standard-form-field spouseResidenceCountry-field">
          <app-country-select
            class="country-select"
            [fieldControl]="controls.spouseResidenceCountry"
            [fieldKey]="'spouseResidenceCountry'"
            [isRequired]="false"
            [fieldLabelKey]="'RESIDENCE-COUNTRY'">
          </app-country-select>
        </div>
        @if (controls.spouseResidencePostalCode; as spouseResidencePostalCode) {
          <div class="standard-form-field spouseResidencePostalCode-field">
            <label
              for="spouseResidencePostalCodeInput"
              [class.invalid]="spouseResidencePostalCode.touched && spouseResidencePostalCode.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-POSTAL-CODE.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="spouseResidencePostalCodeInput"
                type="text"
                maxLength="6"
                minLength="6"
                [mask]="'00-000'"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-POSTAL-CODE.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="false"
                [attr.aria-invalid]="
                  spouseResidencePostalCode.touched && spouseResidencePostalCode.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  spouseResidencePostalCode.touched && spouseResidencePostalCode.invalid
                    ? 'spouseResidencePostalCodeError'
                    : null
                "
                [formControl]="spouseResidencePostalCode" />
              <!-- ERROR -->
              @if (spouseResidencePostalCode.touched && spouseResidencePostalCode.invalid) {
                <mat-error id="spouseResidencePostalCodeError">
                  {{ spouseResidencePostalCode.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.spouseResidenceCountry?.value?.toLowerCase() === 'polska') {
          @if (controls.spouseResidenceVoivodeshipDetailsId; as spouseResidenceVoivodeshipDetailsId) {
            <div class="standard-form-field spouseResidenceVoivodeshipDetailsId-field">
              <label
                id="spouseResidenceVoivodeshipDetailsIdLabel"
                [class.invalid]="
                  spouseResidenceVoivodeshipDetailsId.touched && spouseResidenceVoivodeshipDetailsId.invalid
                ">
                {{ 'PERSONAL_DATA_FORM.RESIDENCE-VOIVODESHIP-NAME.MAIN-LABEL' | translate }}
              </label>
              @if (voivodeships$ | async; as voivodeships) {
                <mat-form-field appearance="outline">
                  <mat-select
                    [formControl]="spouseResidenceVoivodeshipDetailsId"
                    id="spouseResidenceVoivodeshipDetailsId"
                    panelClass="['standard-select', longer-select']"
                    [attr.aria-required]="false"
                    [attr.aria-labelledby]="'spouseResidenceVoivodeshipDetailsIdLabel'"
                    [attr.aria-invalid]="
                      spouseResidenceVoivodeshipDetailsId.touched && spouseResidenceVoivodeshipDetailsId.invalid
                        ? 'true'
                        : null
                    "
                    [attr.aria-describedby]="
                      spouseResidenceVoivodeshipDetailsId.touched && spouseResidenceVoivodeshipDetailsId.invalid
                        ? 'spouseResidenceVoivodeshipDetailsIdError'
                        : null
                    ">
                    @for (voivo of voivodeships; track voivo) {
                      <mat-option [value]="voivo.id">
                        {{ 'COMMON.VOIVODESHIPS.' + voivo.key | translate }}
                      </mat-option>
                    }
                  </mat-select>
                  <!-- ERROR -->
                  @if (spouseResidenceVoivodeshipDetailsId.touched && spouseResidenceVoivodeshipDetailsId.invalid) {
                    <mat-error id="spouseResidenceVoivodeshipDetailsIdError">
                      {{ spouseResidenceVoivodeshipDetailsId.errors | errorsFormatingAndTranslate }}
                    </mat-error>
                  }
                </mat-form-field>
              }
            </div>
          }
        }
        @if (controls.spouseResidenceCountry?.value?.toLowerCase() !== 'polska') {
          @if (controls.spouseResidenceCity; as spouseResidenceCity) {
            <div class="standard-form-field spouseResidenceCity-field">
              <label
                for="spouseResidenceCityInput"
                [class.invalid]="spouseResidenceCity.touched && spouseResidenceCity.invalid">
                {{ 'PERSONAL_DATA_FORM.RESIDENCE-CITY.MAIN-LABEL' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  id="spouseResidenceCityInput"
                  type="text"
                  maxLength="200"
                  minLength="1"
                  placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-CITY.PLACEHOLDER' | translate }}"
                  [required]="false"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="spouseResidenceCity.touched && spouseResidenceCity.invalid ? 'true' : null"
                  [attr.aria-describedby]="
                    spouseResidenceCity.touched && spouseResidenceCity.invalid ? 'spouseResidenceCityError' : null
                  "
                  [formControl]="spouseResidenceCity" />
                <!-- ERROR -->
                @if (spouseResidenceCity.touched && spouseResidenceCity.invalid) {
                  <mat-error id="spouseResidenceCityError">
                    {{ spouseResidenceCity.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <div class="row">
        @if (controls.spouseResidenceCountry?.value?.toLowerCase() === 'polska') {
          @if (controls.spouseResidenceDistrictId; as spouseResidenceDistrictId) {
            <div class="standard-form-field spouseResidenceDistrictId-field">
              <label
                id="spouseResidenceDistrictIdLabel"
                [class.invalid]="spouseResidenceDistrictId.touched && spouseResidenceDistrictId.invalid">
                {{ 'COMMON.LABEL.DISTRICT' | translate }}
              </label>
              @if (districts$ | async; as districts) {
                <mat-form-field appearance="outline">
                  <mat-select
                    [formControl]="spouseResidenceDistrictId"
                    [disabled]="!controls.spouseResidenceVoivodeshipDetailsId?.value"
                    id="spouseResidenceDistrictId"
                    [panelClass]="['standard-select', 'longer-select']"
                    [attr.aria-required]="false"
                    [attr.aria-labelledby]="'spouseResidenceDistrictIdLabel'"
                    [attr.aria-invalid]="
                      spouseResidenceDistrictId.touched && spouseResidenceDistrictId.invalid ? 'true' : null
                    "
                    [attr.aria-describedby]="
                      spouseResidenceDistrictId.touched && spouseResidenceDistrictId.invalid
                        ? 'spouseResidenceDistrictIdError'
                        : null
                    "
                    class="heightened-select">
                    @if (loadingDistricts$ | async) {
                      <mat-option role="status" aria-live="polite">
                        <span class="sr-only">
                          {{ 'COMMON.LAYOUT.LOADING' | translate }}
                        </span>
                        <mat-spinner [diameter]="25" [attr.aria-hidden]="true"> </mat-spinner>
                      </mat-option>
                    }
                    @for (district of districts; track district) {
                      <mat-option [value]="district.id">
                        {{ district.MOS_name.toUpperCase() }} ({{ district.MOS_extra_name.toUpperCase() }})
                      </mat-option>
                    }
                  </mat-select>
                  <!-- ERROR -->
                  @if (spouseResidenceDistrictId.touched && spouseResidenceDistrictId.invalid) {
                    <mat-error id="spouseResidenceDistrictIdError">
                      {{ spouseResidenceDistrictId.errors | errorsFormatingAndTranslate }}
                    </mat-error>
                  }
                </mat-form-field>
              }
            </div>
          }
          @if (controls.spouserResidenceMunicipalityId; as spouserResidenceMunicipalityId) {
            <div class="standard-form-field spouserResidenceMunicipalityId-field">
              <label
                id="spouserResidenceMunicipalityIdlabel"
                [class.invalid]="spouserResidenceMunicipalityId.touched && spouserResidenceMunicipalityId.invalid">
                {{ 'COMMON.LABEL.MUNICIPALITY' | translate }}
              </label>
              @if (municips$ | async; as municips) {
                <mat-form-field appearance="outline">
                  <mat-select
                    [formControl]="spouserResidenceMunicipalityId"
                    [disabled]="!controls.spouseResidenceDistrictId?.value"
                    id="spouserResidenceMunicipalityId"
                    [panelClass]="['standard-select', 'longer-select']"
                    [attr.aria-required]="false"
                    [attr.aria-labelledby]="'spouserResidenceMunicipalityIdlabel'"
                    [attr.aria-invalid]="
                      spouserResidenceMunicipalityId.touched && spouserResidenceMunicipalityId.invalid ? 'true' : null
                    "
                    [attr.aria-describedby]="
                      spouserResidenceMunicipalityId.touched && spouserResidenceMunicipalityId.invalid
                        ? 'spouserResidenceMunicipalityIdError'
                        : null
                    ">
                    @if (loadingMunicips$ | async) {
                      <mat-option role="status" aria-live="polite">
                        <span class="sr-only">
                          {{ 'COMMON.LAYOUT.LOADING' | translate }}
                        </span>
                        <mat-spinner [diameter]="25" [attr.aria-hidden]="true"> </mat-spinner>
                      </mat-option>
                    }
                    @for (municip of municips; track municip) {
                      <mat-option [value]="municip.id">
                        {{ municip.MOS_name.toUpperCase() }} ({{ municip.MOS_type.toUpperCase() }})
                      </mat-option>
                    }
                  </mat-select>
                  <!-- ERROR -->
                  @if (spouserResidenceMunicipalityId.touched && spouserResidenceMunicipalityId.invalid) {
                    <mat-error id="spouserResidenceMunicipalityIdError">
                      {{ spouserResidenceMunicipalityId.errors | errorsFormatingAndTranslate }}
                    </mat-error>
                  }
                </mat-form-field>
              }
            </div>
          }
          @if (controls.spouseResidenceCityListedId; as spouseResidenceCityListedId) {
            <div class="standard-form-field spouseResidenceCityListedId-field">
              <label
                id="spouseResidenceCityListedIdLabel"
                [class.invalid]="spouseResidenceCityListedId.touched && spouseResidenceCityListedId.invalid">
                {{ 'COMMON.LABEL.CITY_MOS' | translate }}
              </label>
              @if (cities$ | async; as cities) {
                <mat-form-field appearance="outline">
                  <mat-select
                    [formControl]="spouseResidenceCityListedId"
                    [disabled]="!controls.spouserResidenceMunicipalityId?.value"
                    id="spouseResidenceCityListedId"
                    [panelClass]="['standard-select', 'longer-select']"
                    [attr.aria-required]="false"
                    [attr.aria-labelledby]="'spouseResidenceCityListedIdLabel'"
                    [attr.aria-invalid]="
                      spouseResidenceCityListedId.touched && spouseResidenceCityListedId.invalid ? 'true' : null
                    "
                    [attr.aria-describedby]="
                      spouseResidenceCityListedId.touched && spouseResidenceCityListedId.invalid
                        ? 'spouseResidenceCityListedIdError'
                        : null
                    ">
                    @if (loadingCities$ | async) {
                      <mat-option role="status" aria-live="polite">
                        <span class="sr-only">
                          {{ 'COMMON.LAYOUT.LOADING' | translate }}
                        </span>
                        <mat-spinner [diameter]="25" [attr.aria-hidden]="true"></mat-spinner>
                      </mat-option>
                    }
                    @for (city of cities; track city) {
                      <mat-option [value]="city.id">
                        {{ city.MOS_name.toUpperCase() }}
                      </mat-option>
                    }
                  </mat-select>
                  <!-- ERROR -->
                  @if (spouseResidenceCityListedId.touched && spouseResidenceCityListedId.invalid) {
                    <mat-error id="spouseResidenceCityListedIdError">
                      {{ spouseResidenceCityListedId.errors | errorsFormatingAndTranslate }}
                    </mat-error>
                  }
                </mat-form-field>
              }
            </div>
          }
        }
        @if (controls.spouseResidenceCountry?.value?.toLowerCase() !== 'polska') {
          @if (controls.spouseResidenceStreet; as spouseResidenceStreet) {
            <div class="standard-form-field spouseResidenceStreet-field">
              <label
                for="spouseResidenceStreetInput"
                [class.invalid]="spouseResidenceStreet.touched && spouseResidenceStreet.invalid">
                {{ 'COMMON.LABEL.STREET_NAME' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  id="spouseResidenceStreetInput"
                  type="text"
                  maxLength="200"
                  minLength="1"
                  placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-STREET.PLACEHOLDER' | translate }}"
                  [required]="false"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="spouseResidenceStreet.touched && spouseResidenceStreet.invalid ? 'true' : null"
                  [attr.aria-describedby]="
                    spouseResidenceStreet.touched && spouseResidenceStreet.invalid
                      ? 'spouseResidenceStreetError spouseResidenceStreetTooltip'
                      : 'spouseResidenceStreetTooltip'
                  "
                  [formControl]="spouseResidenceStreet" />
                <!-- TOOLTIP -->
                <app-cr-form-field-tooltip
                  [id]="'spouseResidenceStreetTooltip'"
                  class="info-suffix-icon"
                  matSuffix
                  [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
                </app-cr-form-field-tooltip>
                <!-- ERROR -->
                @if (spouseResidenceStreet.touched && spouseResidenceStreet.invalid) {
                  <mat-error id="spouseResidenceStreetError">
                    {{ spouseResidenceStreet.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
          @if (controls.spouseResidenceHouseNumber; as spouseResidenceHouseNumber) {
            <div class="standard-form-field spouseResidenceHouseNumber-field">
              <label
                for="spouseResidenceHouseNumberInput"
                [class.invalid]="spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid">
                {{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.MAIN-LABEL' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  id="spouseResidenceHouseNumberInput"
                  type="text"
                  maxLength="20"
                  minLength="1"
                  placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.PLACEHOLDER' | translate }}"
                  [required]="false"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid
                      ? 'spouseResidenceHouseNumberError spouseResidenceHouseNumberTooltip'
                      : 'spouseResidenceHouseNumberTooltip'
                  "
                  [formControl]="spouseResidenceHouseNumber" />
                <!-- TOOLTIP -->
                <app-cr-form-field-tooltip
                  [id]="'spouseResidenceHouseNumberTooltip'"
                  class="info-suffix-icon"
                  matSuffix
                  [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
                </app-cr-form-field-tooltip>
                <!-- ERROR -->
                @if (spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid) {
                  <mat-error id="spouseResidenceHouseNumberError">
                    {{ spouseResidenceHouseNumber.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
          @if (controls.spouseResidenceApartmentNumber; as spouseResidenceApartmentNumber) {
            <div class="standard-form-field spouseResidenceApartmentNumber-field">
              <label
                for="spouseResidenceApartmentNumberInput"
                [class.invalid]="spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid">
                {{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.MAIN-LABEL' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  id="spouseResidenceApartmentNumberInput"
                  type="text"
                  maxLength="20"
                  placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.PLACEHOLDER' | translate }}"
                  [required]="false"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid
                      ? 'spouseResidenceApartmentNumberError spouseResidenceApartmentNumberTooltip'
                      : 'spouseResidenceApartmentNumberTooltip'
                  "
                  [formControl]="spouseResidenceApartmentNumber"
                  (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()" />
                <!-- TOOLTIP -->
                <app-cr-form-field-tooltip
                  [id]="'spouseResidenceApartmentNumberTooltip'"
                  class="info-suffix-icon"
                  matSuffix
                  [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
                </app-cr-form-field-tooltip>
                <!-- ERROR -->
                @if (spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid) {
                  <mat-error id="spouseResidenceApartmentNumberError">
                    {{ spouseResidenceApartmentNumber.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      @if (controls.spouseResidenceCountry?.value?.toLowerCase() === 'polska') {
        <div class="row">
          @if (controls.spouseResidenceStreet; as spouseResidenceStreet) {
            <div class="standard-form-field spouseResidenceStreet-field">
              <label
                for="spouseResidenceStreetInputPoland"
                [class.invalid]="spouseResidenceStreet.touched && spouseResidenceStreet.invalid">
                {{ 'COMMON.LABEL.STREET_NAME' | translate }}
                <span aria-hidden="true">&nbsp;*</span>
                <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
              </label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  id="spouseResidenceStreetInputPoland"
                  type="text"
                  maxLength="200"
                  minLength="1"
                  placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-STREET.PLACEHOLDER' | translate }}"
                  [required]="false"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="spouseResidenceStreet.touched && spouseResidenceStreet.invalid ? 'true' : null"
                  [attr.aria-describedby]="
                    spouseResidenceStreet.touched && spouseResidenceStreet.invalid
                      ? 'spouseResidenceStreetError spouseResidenceStreetTooltip'
                      : 'spouseResidenceStreetTooltip'
                  "
                  [formControl]="spouseResidenceStreet" />
                <!-- TOOLTIP -->
                <app-cr-form-field-tooltip
                  [id]="'spouseResidenceStreetTooltip'"
                  class="info-suffix-icon"
                  matSuffix
                  [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
                </app-cr-form-field-tooltip>
                <!-- ERROR -->
                @if (spouseResidenceStreet.touched && spouseResidenceStreet.invalid) {
                  <mat-error id="spouseResidenceStreetError">
                    {{ spouseResidenceStreet.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
          @if (controls.spouseResidenceHouseNumber; as spouseResidenceHouseNumber) {
            <div class="standard-form-field spouseResidenceHouseNumber-field">
              <label
                for="spouseResidenceHouseNumberInputPoland"
                [class.invalid]="spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid">
                {{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.MAIN-LABEL' | translate }}
                <span aria-hidden="true">&nbsp;*</span>
                <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
              </label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  id="spouseResidenceHouseNumberInputPoland"
                  type="text"
                  maxLength="20"
                  minLength="1"
                  placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.PLACEHOLDER' | translate }}"
                  [required]="false"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid
                      ? 'spouseResidenceHouseNumberError spouseResidenceHouseNumberTooltip'
                      : 'spouseResidenceHouseNumberTooltip'
                  "
                  [formControl]="spouseResidenceHouseNumber" />
                <!-- TOOLTIP -->
                <app-cr-form-field-tooltip
                  [id]="'spouseResidenceHouseNumberTooltip'"
                  class="info-suffix-icon"
                  matSuffix
                  [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
                </app-cr-form-field-tooltip>
                <!-- ERROR -->
                @if (spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid) {
                  <mat-error id="spouseResidenceHouseNumberError">
                    {{ spouseResidenceHouseNumber.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
          @if (controls.spouseResidenceApartmentNumber; as spouseResidenceApartmentNumber) {
            <div class="standard-form-field spouseResidenceApartmentNumber-field">
              <label
                for="spouseResidenceApartmentNumberInputPoland"
                [class.invalid]="spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid">
                {{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.MAIN-LABEL' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  id="spouseResidenceApartmentNumberInputPoland"
                  type="text"
                  maxLength="20"
                  placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.PLACEHOLDER' | translate }}"
                  [required]="false"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid
                      ? 'spouseResidenceApartmentNumberError spouseResidenceApartmentNumberTooltip'
                      : 'spouseResidenceApartmentNumberTooltip'
                  "
                  [formControl]="spouseResidenceApartmentNumber"
                  (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()" />
                <!-- TOOLTIP -->
                <app-cr-form-field-tooltip
                  [id]="'spouseResidenceApartmentNumberTooltip'"
                  class="info-suffix-icon"
                  matSuffix
                  [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
                </app-cr-form-field-tooltip>
                <!-- ERROR -->
                @if (spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid) {
                  <mat-error id="spouseResidenceApartmentNumberError">
                    {{ spouseResidenceApartmentNumber.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
      }
    }
  </div>
</form>
